import {
  loadOffersForPromotions,
  type Promotion,
  type PromotionOffer,
} from '@/lib/offers-by-group';
import type { ListOffer } from '@/lib/goliath/offers';
import type { StageSliderData } from '~/lib/promotions-type';

const parseDate = (date: string): Date | undefined => {
  const dateParts = date.match(/(\d+)/g);
  if (!dateParts || dateParts.length < 3) return undefined;
  return new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0]);
};

const getPromotionStartDate = (startDate: string | undefined): number => {
  // if undefined then startDate shouldn't matter
  // -> 0
  if (!startDate) return 0;
  return parseDate(startDate)?.getTime() || 0;
};
const getPromotionEndDate = (endDate: string | undefined): number => {
  // if undefined then endDate shouldn't matter
  // -> Infinity
  if (!endDate) return Infinity;
  return parseDate(endDate)?.getTime() || Infinity;
};

export const getActivePromotions = async (
  promotions: Promotion<StageSliderData>[],
  dateToday: number
): Promise<PromotionOffer<ListOffer, StageSliderData>[]> => {
  const activePromotions = promotions?.filter((promotion) => {
    if (promotion.type !== 'stage') return false;
    const startDate = getPromotionStartDate(promotion.startDate);
    const endDate = getPromotionEndDate(promotion.endDate);

    if (startDate > endDate) {
      throw new Error(`startDate can't be later then endDate for ${promotion.headline?.text}`);
    }

    return startDate < dateToday && endDate > dateToday;
  });

  return loadOffersForPromotions(activePromotions);
};
